// Copyright (c) Docugami, Inc. All rights reserved.
export abstract class ComparisonUnit
{
    public contents: ComparisonUnit[] = [];
}
